import { useState, useEffect } from 'react';

// icons
import { ArrowUpRight } from 'lucide-react';

// components
import TermsModal from './components/TermsModal';
import PrivacyModal from './components/PrivacyModal';

// assets
import logo from './logo.svg';

// styles
import './App.css';

function App() {
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  useEffect(() => {
    const handleHash = () => {
      const hash = window.location.hash;
      setTermsOpen(hash === '#terms');
      setPrivacyOpen(hash === '#privacy');
    };

    handleHash();
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);

    const closeTerms = () => {
            window.history.replaceState(null, '', ' ');
            setTermsOpen(false);
        };

        const closePrivacy = () => {
            window.history.replaceState(null, '', ' ');
            setPrivacyOpen(false);
    };

  return (
    <div className="App">
      <header className="App-header">
        <a className="App-brand" href="/" aria-label="Tolvai Company">
          <img src={logo} className="App-header-logo" alt="Tolvai Company" />
        </a>

        <nav className="App-nav">
          <a href="#company">Company</a>
          <a href="#products">Products</a>
        </nav>
      </header>

      <main className="App-main">
        <section className="App-hero">
          <div className="App-hero-content">
            <span className="App-eyebrow">Tolvai Company LLC</span>

            <h1>
              Building technology for a
              <span> more open digital world.</span>
            </h1>

            <p className="App-hero-description">
              We build and operate digital products focused on infrastructure,
              accessibility and decentralized technology.
            </p>

            <a className="App-hero-link" href="#company">
              Discover Tolvai
              <span>↓</span>
            </a>
          </div>

          <div className="App-hero-mark">
            <img src={logo} alt="" aria-hidden="true" />
          </div>
        </section>

        <div className="App-stack">
          <section className="App-panel-stage" id="company">
            <div className="App-panel App-company">
              <div className="App-panel-number">
                01
              </div>

              <div className="App-company-content">
                <span className="App-section-label">
                  Company
                </span>

                <h2>
                  Independent technology company.
                </h2>

                <p>
                  Tolvai Company LLC develops and operates digital products
                  designed around simplicity, autonomy and modern technology.
                </p>
              </div>
            </div>
          </section>

          <section className="App-panel-stage App-panel-stage-products" id="products">
            <div className="App-panel App-products">

              <div className="App-products-heading">
                <div>
                  <span className="App-section-label">
                    Products
                  </span>

                  <h2>
                    Technology built
                    <br />
                    with purpose.
                  </h2>
                </div>

                <span className="App-panel-number">
                  02
                </span>
              </div>

              <a
                className="App-product"
                href="https://beeswarm.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="App-product-main">
                  <div className="App-product-icon">
                    <img
                      src="https://beeswarm.app/icon-192x192.png"
                      alt="BeeSwarm"
                    />
                  </div>

                  <div className="App-product-title">
                    <span>001 / Digital infrastructure</span>
                    <h3>BeeSwarm</h3>
                  </div>
                </div>

                <div className="App-product-side">
                  <p>
                    Self-custodial infrastructure for digital assets,
                    payments and decentralized tools.
                  </p>

                  <div className="App-product-visit">
                    <span>Visit BeeSwarm</span>

                    <span className="App-product-arrow">
                      <ArrowUpRight size={19} strokeWidth={1.5} />
                    </span>
                  </div>
                </div>
              </a>

              <footer className="App-footer">
                <span className="App-footer-company">
                  Tolvai Company LLC
                </span>

                <div className="App-footer-meta">
                    <span>Wyoming, United States</span>
                    <a
                        className="App-footer-terms"
                        href="https://x.com/tolvaicompany"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Twitter
                    </a>
                    <a
                        className="App-footer-terms"
                        href="https://linkedin.com/company/tolvaicompany"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        LinkedIn
                    </a>
                    <button
                        className="App-footer-terms"
                        onClick={() => { window.history.replaceState(null, '', '#terms'); setTermsOpen(true); }}
                    >
                        Terms of Use
                    </button>
                    <button
                        className="App-footer-terms"
                        onClick={() => { window.history.replaceState(null, '', '#privacy'); setPrivacyOpen(true); }}
                    >
                        Privacy Policy
                    </button>
                    <span>© {new Date().getFullYear()}</span>
                    </div>
              </footer>
            </div>
          </section>
        </div>
      </main>

      <TermsModal isOpen={termsOpen} onClose={closeTerms} />
      <PrivacyModal isOpen={privacyOpen} onClose={closePrivacy} />
    </div>
  );
}

export default App;